module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-f2870c0d717e50654c825b02086c5135.png";